<template>
  <div class="mt-4">
    <div class="container">
      <div class="row" v-if="isLoading">
        <div class="col-12 text-center">
          <HMSpinner />
        </div>
      </div>
      <div class="row" v-if="!isLoading && hasPodcasts">
        <div v-if="!hasPodcasts" class="text-center w-100">
          <HMEmpty
            image=""
            :title="$t('PODCASTS.TITLES.NO_PODCASTS')"
            :description="$t('PODCASTS.TEXT.NO_PODCASTS_ACCESS')"
          />
        </div>
        <div class="col-12 col-md-7">
          <div class="border p-4 rounded">
            <div class="row">
              <div class="col-12">
                <h3 class="mb-4">{{ $t('STUDIO.LINKS.PODCASTS') }}</h3>
              </div>
              <div
                class="col-12 col-lg-6 mb-4"
                v-for="podcast in podcasts"
                :key="podcast.id"
              >
                <router-link
                  class="undecorated-router-link"
                  :is="podcast.user_left_this_group ? 'span' : 'router-link'"
                  :to="{
                    name: 'studio-podcast-details',
                    params: { podcast_id: podcast.id, studio_url: studioURL },
                  }"
                  @click="$emit('close')"
                >
                  <router-link
                    class="undecorated-router-link"
                    :to="{
                      name: 'studio-podcast-details',
                      params: { podcast_id: podcast.id, studio_url: studioURL },
                    }"
                  >
                    <StudioPodcastCard :podcast="podcast" />
                  </router-link>
                </router-link>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-5 mt-4 mt-md-0">
          <div class="border rounded h-100">
            <div class="row">
              <div class="col-12">
                <h3 class="mb-4 px-4 pt-4">
                  {{ $t('PODCASTS.TITLES.RECENT_EPISODES') }}
                </h3>
              </div>
              <div class="col-12 text-center" v-if="isLoadingRecentEpisodes">
                <HMSpinner />
              </div>
              <div
                class="col-12"
                v-for="episode in recentEpisodes"
                :key="episode.id"
              >
                <router-link
                  class="undecorated-router-link"
                  :to="{
                    name: 'studio-podcast-episode-details',
                    params: {
                      podcast_id: episode.podcast,
                      episode_id: episode.id,
                    },
                  }"
                >
                  <EpisodeItem :episode="episode" />
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row" v-if="!isLoading && !hasPodcasts">
        <div class="col-12">
          <HMNoDataCard
            :title="$t('PODCASTS.TITLES.NO_PODCASTS')"
            :description="$t('PODCASTS.TEXT.NO_PODCASTS_ACCESS')"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';
import { errorToMessage } from '../../../core/utils/errors';
import RefreshData from '@/web/mixins/refreshData';
import { getStudioURL } from '@/web/router/custom-domain-utils';
import StudioPodcastCard from '../../components/podcasts/StudioPodcastCard';
import EpisodeItem from '../../components/podcasts/EpisodeItem';

export default Vue.extend({
  name: 'StudioPodcasts',
  mixins: [RefreshData],
  components: {
    StudioPodcastCard,
    EpisodeItem,
  },
  computed: {
    ...mapGetters({
      studentMagicCode: 'user/studentMagicCode',
      interactAsStudio: 'community/interactAsStudio',
    }),
    studioURL() {
      return getStudioURL(this.$route);
    },
    hasPodcasts() {
      return this.podcasts?.length > 0;
    },
  },
  data() {
    return {
      isLoading: true,
      isLoadingRecentEpisodes: true,
      podcasts: [],
      recentEpisodes: [],
    };
  },
  methods: {
    async loadRecentEpisodes() {
      this.isLoadingRecentEpisodes = true;
      try {
        this.recentEpisodes = await this.$store.dispatch(
          'podcasts/loadStudioRecentEpisodes',
          {
            studioURL: this.studioURL,
          }
        );
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: 'Failed to load recent episodes',
          text: errorToMessage(error?.response, `Request failed: ${error}`),
          duration: -1,
        });
      } finally {
        this.isLoadingRecentEpisodes = false;
      }
    },
    async loadData() {
      this.isLoading = true;
      try {
        this.podcasts = await this.$store.dispatch(
          'podcasts/loadStudioPodcasts',
          {
            studioURL: this.studioURL,
          }
        );
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: 'Failed to load podcasts',
          text: errorToMessage(error?.response, `Request failed: ${error}`),
          duration: -1,
        });
      } finally {
        this.isLoading = false;
      }
    },
  },
  mounted() {
    this.loadData();
    this.loadRecentEpisodes();
  },
});
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';
</style>
